import { buildAdyenBookingContext } from '@services/utils/adyen-booking-context.util';
import { SelectedBookingDataModel } from '@models/selected-booking-data.model';

/**
 * What a paid Adyen session is bound to on the page: the booked worker, every cart item's service
 * and slot, and the coupon. A resumed payment is handed to `/book` only while this is unchanged -
 * otherwise a payment made for one slot would book another at the same price. The backend claims
 * each session once; this closes the gap in the browser before it gets there.
 *
 * Deterministic for the same booking (a plain JSON string, fixed key order), so a record written
 * before the redirect and the restored booking after it compare equal.
 */
export function buildAdyenHoldScope(bookingData: SelectedBookingDataModel | undefined): string {
  const items = (bookingData?.cartItems ?? []).map(item => ({
    service: item?.serviceId ?? item?.service?.id ?? null,
    worker: item?.workerId ?? null,
    start: item?.startTime ?? null,
    end: item?.endTime ?? null,
  }));

  return JSON.stringify({
    worker: buildAdyenBookingContext(bookingData).worker_id ?? null,
    items,
    coupon: bookingData?.selectedCoupon?.code ?? null,
  });
}
